<!--在中间的系统消息-->
<template>
	<div class="infoBody">
		<span class="msgSpan">{{messageBody}}</span>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {
			headPic: {
				type: String,
				default: resourcesStore.getters.getResourcesByName('/unitInfo/circle_bg.png')
			},
			userName: {
				type: String
			},
			messageBody: {
				type: String
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.infoBody {
		margin: 12px;
		text-align: center;
		font-size: 12px;
	}

	.msgSpan {
		display: inline-block;
		padding: 4px;
		background-color: #ccc;
		color: #fff;
		-moz-border-radius: 6px;
		-webkit-border-radius: 6px;
		border-radius: 6px;
		text-align: center;
		font-size: 12px;
	}
</style>
